import { CurrencyCode } from '../../gen/types'
import {
  CF_ALL_ACCESS_MONTHLY_PRICE_OTHER,
  CF_ALL_ACCESS_MONTHLY_PRICE_USD,
  CF_ALL_ACCESS_YEARLY_PRICE,
  CF_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE,
  CF_STUDIO_AI_YEARLY_PROMO_MONTHLY_SPLIT_PRICE,
  CF_ALL_ACCESS_YEARLY_PROMO_PRICE,
  CF_STUDIO_AI_YEARLY_PROMO_PRICE,
  CF_TEAM_MONTHLY_PRICE,
} from 'constants/prices'

export type Cost = Partial<Record<CurrencyCode, number>>

type Costs = Record<
  'yearly' | 'monthly' | 'promotion' | 'yearlyTrial' | 'aiStudioTrial' | 'aiStudio' | 'teamMonthly',
  Cost
>

export const cfCosts: Costs = {
  yearly: {
    [CurrencyCode.Usd]: CF_ALL_ACCESS_YEARLY_PRICE,
    [CurrencyCode.Eur]: CF_ALL_ACCESS_YEARLY_PRICE,
    [CurrencyCode.Gbp]: CF_ALL_ACCESS_YEARLY_PRICE,
  },
  promotion: {
    [CurrencyCode.Usd]: CF_ALL_ACCESS_YEARLY_PROMO_PRICE,
    [CurrencyCode.Eur]: CF_ALL_ACCESS_YEARLY_PROMO_PRICE,
    [CurrencyCode.Gbp]: CF_ALL_ACCESS_YEARLY_PROMO_PRICE,
  },
  monthly: {
    [CurrencyCode.Usd]: CF_ALL_ACCESS_MONTHLY_PRICE_USD,
    [CurrencyCode.Eur]: CF_ALL_ACCESS_MONTHLY_PRICE_OTHER,
    [CurrencyCode.Gbp]: CF_ALL_ACCESS_MONTHLY_PRICE_OTHER,
  },
  yearlyTrial: {
    [CurrencyCode.Usd]: CF_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE,
    [CurrencyCode.Eur]: CF_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE,
    [CurrencyCode.Gbp]: CF_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE,
  },
  aiStudioTrial: {
    [CurrencyCode.Usd]: CF_STUDIO_AI_YEARLY_PROMO_MONTHLY_SPLIT_PRICE,
    [CurrencyCode.Eur]: CF_STUDIO_AI_YEARLY_PROMO_MONTHLY_SPLIT_PRICE,
    [CurrencyCode.Gbp]: CF_STUDIO_AI_YEARLY_PROMO_MONTHLY_SPLIT_PRICE,
  },
  aiStudio: {
    [CurrencyCode.Usd]: CF_STUDIO_AI_YEARLY_PROMO_PRICE,
    [CurrencyCode.Eur]: CF_STUDIO_AI_YEARLY_PROMO_PRICE,
    [CurrencyCode.Gbp]: CF_STUDIO_AI_YEARLY_PROMO_PRICE,
  },
  teamMonthly: {
    [CurrencyCode.Usd]: CF_TEAM_MONTHLY_PRICE,
    [CurrencyCode.Eur]: CF_TEAM_MONTHLY_PRICE,
    [CurrencyCode.Gbp]: CF_TEAM_MONTHLY_PRICE,
  },
}

export const defaultFreeTrialMonthlyRenewal = CF_ALL_ACCESS_MONTHLY_PRICE_USD
export const defaultFreeTrialYearlyRenewal = CF_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE

export function getCostForCurrency(
  cost: Cost | undefined,
  currencyCode: CurrencyCode,
  fallback = 0,
) {
  return cost?.[currencyCode] ?? fallback
}
